import React, { Component } from 'react';
import { Box } from 'grommet/components/Box';
import { Anchor } from 'grommet/components/Anchor';
import { Image } from 'grommet/components/Image';
import logo from '../Assets/logoamex.svg';
import { logout } from '../Utils/Utility';

class HeaderLogout extends Component {


  render() {


    return (

      <Box id='header' direction='row' className='box-shadow' style={{ padding: '0' }}>
        <Box style={{ position: 'static', padding: '0 20px', maxWidth: '1240px', margin: '0 auto', width: '1240px', display: 'inline' }} className='pagination'>
          <Image id='logoheader' style={{ margin: '10px 0', verticalAlign: 'middle', float: 'left' }} src={logo} alt="logo" />
          
          <div id='marginlink' style={{ verticalAlign: 'middle', float: 'right', textDecoration: 'none', cursor: 'default' }}>
            <Anchor id='linkheader2' href='https://www.americanexpress.com/it/merchant/?inav=it_menu_business_merch_home' target='blank'>Esercizi Commerciali</Anchor>
            <button
  id="linkheader"
  onClick={logout}
  style={{
    background: 'none',
    border: 'none',
    color: '#0070f3',
    cursor: 'pointer',
    textDecoration: 'underline',
    font: 'inherit',
    padding: 0
  }}
>
  Esci
</button>
          </div>

        </Box>
      </Box>
    );
  }
}

export default HeaderLogout;
